export default __webpack_public_path__ + "static/media/managepr_navicon-light.bf7d551b.svg";